import { axios } from "../../lib/axios";

export const DeleteCourse = (courseId: string) => {
    return axios.delete(`/course/${courseId}`)
        .then(response => response.data);
};